import { useQuery } from '@tanstack/react-query';
import type { PositionDto } from '@bstm/shared';
import { api } from '../api/client';

export default function Positions() {
  const q = useQuery<{ positions: PositionDto[] }>({
    queryKey: ['positions'],
    queryFn: () => api('/positions'),
  });

  return (
    <div className="p-4 md:p-6 max-w-3xl">
      <h1 className="text-xl md:text-2xl font-semibold mb-2">Positions</h1>
      <p className="text-xs md:text-sm text-zinc-500 mb-4 md:mb-6">
        Net shares from FILLED tickets only.
      </p>
      <div className="card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-zinc-950 text-zinc-400 text-left">
            <tr>
              <th className="px-3 md:px-4 py-2">Ticker</th>
              <th className="hidden sm:table-cell px-4 py-2 text-right">Bought</th>
              <th className="hidden sm:table-cell px-4 py-2 text-right">Sold</th>
              <th className="px-3 md:px-4 py-2 text-right">Net</th>
            </tr>
          </thead>
          <tbody>
            {q.data?.positions.map((p) => (
              <tr key={p.ticker} className="border-t border-zinc-800">
                <td className="px-3 md:px-4 py-2 font-mono">{p.ticker}</td>
                <td className="hidden sm:table-cell px-4 py-2 text-right font-mono text-emerald-400">{p.totalBought.toLocaleString()}</td>
                <td className="hidden sm:table-cell px-4 py-2 text-right font-mono text-red-400">{p.totalSold.toLocaleString()}</td>
                <td className={`px-3 md:px-4 py-2 text-right font-mono font-semibold ${p.netShares >= 0 ? 'text-emerald-300' : 'text-red-300'}`}>
                  {p.netShares.toLocaleString()}
                </td>
              </tr>
            ))}
            {q.data?.positions.length === 0 && (
              <tr>
                <td colSpan={4} className="text-center text-zinc-500 py-8">No filled tickets yet.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
